import { render, staticRenderFns } from "./myteam.vue?vue&type=template&id=7ed74168&scoped=true"
import script from "./myteam.vue?vue&type=script&lang=js"
export * from "./myteam.vue?vue&type=script&lang=js"
import style0 from "./myteam.vue?vue&type=style&index=0&id=7ed74168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed74168",
  null
  
)

export default component.exports